export const style = (theme) => ({
  contentExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#909090",
  },
  numberExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#292f48",
  },
  wrapText: {
    width: "100%",
  },
});
